<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
*,*::before,*::after{
  box-sizing: border-box;
}
html{
  height: 100%
}
body{
  margin: 0;
  height: 100%;
}
#app{
  height: 100%;
}
a{
  text-decoration: none;
}
.screen {
  padding-top: 30px;
  width: 640px;
  margin: 0 auto;
}
.screen-title{
  font-size: 18px;
  margin-bottom: 30px;
  padding-left: 10px;
}
.el-form-item__content{
  display: flex;
}
.el-page-header__content{
    color: #fff;
    font-weight: 600;
}
.el-aside{
  border-right: solid 1px #e6e6e6;
}
.el-menu{
  border-right: solid 0px #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue